import React, {useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {Hub, Logger} from '@aws-amplify/core';
import {AuthService} from "../../services/auth-service";
import logo from '../../images/logo.png';
import {
    Container,
    Row,
    Col,
    Label,
    FormGroup,
    Button,
    Card,
    CardBody
  } from "reactstrap";
import {notification} from 'antd';
import FeatherIcon from "feather-icons-react";
import user02 from "../../assets/images/user/tech-cloud-bg-2.jpg";
import { AvForm, AvField } from "availity-reactstrap-validation";

export function RegisterForm() {

    const getUrlParameter = (name) => {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]'); //eslint-disable-line
      const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
      const results = regex.exec(window.location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };
    const logger = new Logger("RegisterForm");
    const history = useHistory();

    //const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        Hub.listen(AuthService.CHANNEL, onHubCapsule, 'MyListener');


        return function cleanup() {
            logger.info("Removing HUB subscription to " + AuthService.CHANNEL);
            Hub.remove(AuthService.CHANNEL, onHubCapsule);
        };
    });


    // Default handler for listening events
    const onHubCapsule = (capsule) => {
        const {channel, payload} = capsule;
        if (channel === AuthService.CHANNEL && payload.event === AuthService.AUTH_EVENTS.REGISTER) {
            if (!payload.success) {
                //setErrorMessage(payload.message);
                notification.open({
                    type: 'error',
                    message: 'Could not register',
                    description: payload.message,
                    duration: 10
                });
            } else {
                // Successful registration -- now let's confirm the email with a code (route to the next screen)
                history.push("/registerconfirm")
            }
        }
    };

    const onFinish = (event, values) => {
      const regToken = getUrlParameter('x-amzn-marketplace-token')
      if(regToken && regToken) {
        AuthService.subscribeHandler(regToken , values.email)
      }
      AuthService.register(values.email, values.password);
    };


    return <React.Fragment>
    
    <section className="cover-user bg-white" style={{width:'100%'}}>
      <Container fluid className="px-0">
        <Row className="no-gutters position-relative">
          <Col lg={4} xs={{ order: 2 }} className="cover-my-30 ">
            <div className="cover-user-img d-flex align-items-center">
              <Row>
                <Col xs={12}>
                  <Card
                    className="login-page border-0"
                    style={{ zIndex: 1 }}
                  >
                    <CardBody className="p-0">
                    <Row style={{justifyContent: 'center'}}>
                            <img src={logo} style={{width : '150px', height : '150px'}} alt=""></img>
                        </Row>
                      <h4 className="card-title text-center">Signup</h4>
                      <AvForm  onValidSubmit={onFinish} className="login-form mt-4">
                        <Row>
                          <Col md="12">
                            <FormGroup className="position-relative">
                              <Label for="email">
                                Your Email{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <div className="position-relative">
                                <i>
                                  <FeatherIcon 
                                    icon="mail"
                                    className="fea icon-sm icons"
                                  />
                                </i>
                              </div>
                              <AvField style={{marginLeft:'10px'}}
                                type="text"
                                className="form-control pl-5"
                                name="email"
                                id="email"
                                placeholder="Enter Email"
                                required
                                errorMessage=""
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please enter your email",
                                  },
                                  pattern: {
                                    value:
                                      "^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$",
                                    errorMessage: "E-Mail is not valid!",
                                  },
                                }}
                              />
                            </FormGroup>
                          </Col>

                          <Col md="12">
                            <FormGroup className="position-relative">
                              <Label for="password">
                                Password{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <div className="position-relative">
                                <i>
                                  <FeatherIcon
                                    icon="lock"
                                    className="fea icon-sm icons"
                                  />
                                </i>
                              </div>
                              <AvField style={{marginLeft:'10px'}}
                                type="password"
                                className="form-control pl-5"
                                name="password"
                                id="password"
                                placeholder="Enter password"
                                required
                                errorMessage=""
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please enter Password",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage:
                                      "Your password must be between 6 and 8 characters",
                                  },
                                  maxLength: {
                                    value: 16,
                                    errorMessage:
                                      "Your password must be between 6 and 8 characters",
                                  },
                                }}
                              />
                            </FormGroup>
                          </Col>

                          <Col md="12">
                            <FormGroup className="position-relative">
                              <Label for="confirmpassword">
                                Confirm Password{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <div className="position-relative">
                                <i>
                                  <FeatherIcon
                                    icon="lock"
                                    className="fea icon-sm icons"
                                  />
                                </i>
                              </div>
                              <AvField style={{marginLeft:'10px'}}
                                type="password"
                                className="form-control pl-5"
                                name="confirmpassword"
                                id="confirmpassword"
                                placeholder="Confirm Password"
                                required
                                errorMessage=""
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please enter Password",
                                  },
                                  minLength: {
                                    value: 6,
                                    errorMessage:
                                      "Your password must be between 6 and 8 characters",
                                  },
                                  maxLength: {
                                    value: 16,
                                    errorMessage:
                                      "Your password must be between 6 and 8 characters",
                                  },
                                }}
                              />
                            </FormGroup>
                          </Col>

                          {/* <Col md="12">
                            <FormGroup>
                              <div className="custom-control custom-checkbox">
                              
                                <AvField
                                  type="checkbox"
                                  style={{left:'-10px', width: '10px'}}
                                 // className="custom-control-input"
                                  name="customCheck1"
                                  id="customCheck1"
                                  label={ <a target="_blank" rel="noopener noreferrer" href='https://cloudplexo.com/page-terms'>I Accept Terms And Condition</a>}
                                  required
                                errorMessage=""
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Please accept Terms And Condition",
                                  }}}
                                />
                                 
                                <Label
                                 // className="custom-control-label"
                                  for="customCheck1"
                                >
                                  I Accept{" "}
                                  <Link to="#" className="text-primary">
                                    Terms And Condition
                                  </Link>
                                </Label>
                              </div>
                            </FormGroup>
                          </Col> */}
                          <Col md="12" className="mb-0">
                            <Button color="primary" block style={{height:'50px'}}>
                              Register
                            </Button>
                          </Col>
                       
                          {/* <Col lg="12" className="mt-4 text-center">
                            <h6>Or Signup With</h6>
                            <ul className="list-unstyled social-icon mb-0 mt-3">
                              <li className="list-inline-item">
                                <Link to="#" className="rounded mr-1">
                                  <i>
                                    <FeatherIcon
                                      icon="facebook"
                                      className="fea icon-sm fea-social"
                                    />
                                  </i>
                                </Link>
                              </li>
                              <li className="list-inline-item">
                                <Link to="#" className="rounded mr-1">
                                  <i>
                                    <FeatherIcon
                                      icon="github"
                                      className="fea icon-sm fea-social"
                                    />
                                  </i>
                                </Link>
                              </li>
                              <li className="list-inline-item">
                                <Link to="#" className="rounded mr-1">
                                  <i>
                                    <FeatherIcon
                                      icon="twitter"
                                      className="fea icon-sm fea-social"
                                    />
                                  </i>
                                </Link>
                              </li>
                              <li className="list-inline-item">
                                <Link to="#" className="rounded">
                                  <i>
                                    <FeatherIcon
                                      icon="gitlab"
                                      className="fea icon-sm fea-social"
                                    />
                                  </i>
                                </Link>
                              </li>
                            </ul>
                          </Col> */}
                          <Col className="text-center">
                            <p className="mb-0 mt-3">
                              <small className="text-dark mr-2">
                                Already have an account ?
                              </small>{" "}
                              <Link
                                to="/login"
                                className="text-dark font-weight-bold"
                              >
                                Sign in
                              </Link>
                            </p>
                          </Col>
                        </Row>
                      </AvForm>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </Col>
          <Col
            lg={8}
            className="offset-lg-4 padding-less img order-1"
            style={{ backgroundImage: `url(${user02})` }}
          ></Col>
        </Row>
      </Container>
    </section>
  </React.Fragment>
    
    
    // <div style={{marginTop : 200, minHeight:'485px'}}>
    //     <Row style={{display: 'flex', justifyContent: 'center', margin: "15px"}}>
    //         <img src={logo} style={{width : '150px', height : '50px'}} alt=""></img>
           
    //     </Row>
    //     <Row style={{display: 'flex', justifyContent: 'center', margin: "15px"}}>
            
    //         Register
    //     </Row>
    //     <Row>
    //         <Form
    //             name="basic"
    //             onFinish={onFinish}
    //             onFinishFailed={onFinishFailed}
    //             style={styles.loginForm}>
    //             <Form.Item
    //                 name="username"
    //                 rules={[
    //                     {
    //                         required: true,
    //                         message: 'Please input your email!',
    //                     }
    //                 ]}>
    //                 <Input
    //                     prefix={<UserOutlined/>}
    //                     placeholder="Email"
    //                 />
    //             </Form.Item>
    //             <Form.Item
    //                 name="password"
    //                 rules={[
    //                     {
    //                         required: true,
    //                         message: 'Please input your Password!'
    //                     }
    //                 ]}>

    //                 <Input
    //                     prefix={<LockOutlined/>}
    //                     type="password"
    //                     placeholder="Password"
    //                 />

    //             </Form.Item>
    //             <Form.Item>
    //                 <Button type="primary" htmlType="submit" style={styles.loginFormButton}>
    //                     Register
    //                 </Button>
    //                 Already registered? <Link to="login">login</Link>
    //             </Form.Item>
    //         </Form>
    //     </Row>
      
    // </div>;

}
